jQuery(document).ready(function($){

    options = {
        isErrorOnParent: true,
        method         : 'blur'
    };

    $('#wepay').validator(options);

});